export function getListOfScheduledDays(schedule) {
    const days = [];
    for (let i = 0; i < schedule.length; i++) {
        const day = schedule[i].date.getDay();
        if (days.indexOf(day) < 0) {
            days.push(day);
        }
    }
    return days;
}
